import React from "react";
import { Link } from "react-router-dom";


import Attention from "./assets/Attention.svg";

const PaymentFailed: React.FC = () => {
    return (
        <>
            <div className=" w-full flex items-center justify-center">
                <div className="  px-4 max-w-[600px] flex flex-col w-full justify-center h-svh items-center">
                    <img src={Attention} className="w-[15%]" alt="" />
                    <p className=" text-xl font-Manrope font-semibold text-black mt-3 text-center">
                        Payment Failed
                    </p>
                    <p className=" mt-3 max-w-[400px] text-center font-Manrope font-normal text-base text-black">
                        Unfortunately, your payment was unsuccessful. Please try again or
                        contact support for assistance.
                    </p>
                    <Link
                        to="/dashboard"
                        className=" bg-[#317333] rounded-md py-3 mt-4 px-4 font-Manrope text-[#fff] font-semibold text-base flex justify-center  items-center"
                    >
                        Return to Dashboard
                    </Link>
                </div>
            </div>
        </>
    );
};

export default PaymentFailed;
